import { useEffect, useRef } from 'react';

export const useOnComponentMount = (callback) => {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) {
      return;
    }
    mounted.current = true;
    return callback();
  }, []); // oxlint-disable-line react-hooks/exhaustive-deps
};
